
$(function() {
	/*$('.has-submenu > a').each(function(){
		var sub = $(this).next('ul');
		$(this).clone().prependTo(sub).wrap('<li class="hide-for-large"></li>');
	});*/
	$(document).foundation();
	iniShareReveal();
	$(window).scroll(function () {($(this).scrollTop() > 20)?$('#back-top').stop(true).addClass('back-top-show'):$('#back-top').stop(true).removeClass('back-top-show');});$('#back-top').click(function () {$('body, html').stop(true).animate({scrollTop: 0}, 600);});	
	
	var elemNavIntern = ['.liens-page-section'], classActive = 'page-actuelle', pageLink = window.location.pathname, pageLinkCln = pageLink.substring(1);
	for(var i=0;i<elemNavIntern.length;i++){
		$(elemNavIntern[i]+' a[href="'+pageLinkCln+'"]').parent('li').addClass(classActive);
	}
	$('#offCanvastop').on('openedEnd.zf.offCanvas',function(){
		if(!$(window).scrollTop()){
			$('html,body').animate({ scrollTop: '5px'});
		}
	});
	//------scrollhide-nav
	var height = isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight;
	var prev = 0;
    var $window = $(window);
    var nav = $('.scrollhide-nav');
	    $window.on('scroll', function () {
        var scrollTop = $window.scrollTop();
		//if($('html').hasClass('is-reveal-open')) return;
			if(!$('#offCanvastop').hasClass('is-open') ){
		
			   if (scrollTop > 300) {
				nav.toggleClass('hidden', scrollTop > prev);
			} else if (nav.hasClass('hidden')) {
				nav.toggleClass('hidden', false);
			}
			   }
			
			prev=scrollTop;
        });
	
});